import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
function cov_2671cx13vl() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx";
  var hash = "34df2cbe97de4b5e1bd1a0de34d7a5e6337d0941";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 44
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 44
        },
        end: {
          line: 28,
          column: 92
        }
      },
      "2": {
        start: {
          line: 29,
          column: 42
        },
        end: {
          line: 29,
          column: 60
        }
      },
      "3": {
        start: {
          line: 30,
          column: 37
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "4": {
        start: {
          line: 33,
          column: 30
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "5": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "6": {
        start: {
          line: 45,
          column: 32
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "7": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 45
        }
      },
      "8": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 34
        }
      },
      "9": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 31
        }
      },
      "10": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 54,
          column: 7
        }
      },
      "11": {
        start: {
          line: 57,
          column: 32
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "12": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 24
        }
      },
      "13": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 27
        }
      },
      "14": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 69,
          column: 6
        }
      },
      "15": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 30
        }
      },
      "16": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 101,
          column: 4
        }
      },
      "17": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 91,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 44
          },
          end: {
            line: 22,
            column: 45
          }
        },
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 27
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 30
          },
          end: {
            line: 33,
            column: 31
          }
        },
        loc: {
          start: {
            line: 33,
            column: 44
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 32
          },
          end: {
            line: 45,
            column: 33
          }
        },
        loc: {
          start: {
            line: 45,
            column: 46
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 57,
            column: 32
          },
          end: {
            line: 57,
            column: 33
          }
        },
        loc: {
          start: {
            line: 57,
            column: 46
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 57
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 19
          }
        },
        loc: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 91,
            column: 14
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 26,
            column: 18
          },
          end: {
            line: 26,
            column: 29
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 85,
            column: 21
          },
          end: {
            line: 85,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 21
          },
          end: {
            line: 85,
            column: 31
          }
        }, {
          start: {
            line: 85,
            column: 35
          },
          end: {
            line: 85,
            column: 58
          }
        }],
        line: 85
      },
      "2": {
        loc: {
          start: {
            line: 95,
            column: 7
          },
          end: {
            line: 99,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 7
          },
          end: {
            line: 95,
            column: 20
          }
        }, {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 98,
            column: 14
          }
        }],
        line: 95
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "34df2cbe97de4b5e1bd1a0de34d7a5e6337d0941"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2671cx13vl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
cov_2671cx13vl();
import "core-js/modules/es.function.name.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { GoogleLogin } from 'react-google-login';
import { Box, Button } from '@opendoor/bricks-next';
import { useObservability } from '@opendoor/observability';
import { t } from "../../i18n/translationHelper.mjs";
import { ErrorPrompt } from "./ErrorPrompt.mjs";
cov_2671cx13vl().s[0]++;
export var GoogleAuth = function GoogleAuth(_ref) {
  var buttonText = _ref.buttonText,
    clientId = _ref.clientId,
    onAuthed = _ref.onAuthed,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? (cov_2671cx13vl().b[0][0]++, 'secondary') : _ref$buttonVariant;
  cov_2671cx13vl().f[0]++;
  var _ref2 = (cov_2671cx13vl().s[1]++, React.useState(null)),
    _ref3 = _slicedToArray(_ref2, 2),
    errorResponse = _ref3[0],
    setErrorResponse = _ref3[1];
  var _ref4 = (cov_2671cx13vl().s[2]++, React.useState('')),
    _ref5 = _slicedToArray(_ref4, 2),
    errorMessage = _ref5[0],
    setErrorMessage = _ref5[1];
  var _ref6 = (cov_2671cx13vl().s[3]++, useObservability()),
    trackError = _ref6.trackError,
    trackEvent = _ref6.trackEvent;

  // Called, e.g., when user is in incognito mode or has otherwise blocked third-party cookies
  cov_2671cx13vl().s[4]++;
  var onScriptLoadFailure = function onScriptLoadFailure(response) {
    cov_2671cx13vl().f[1]++;
    cov_2671cx13vl().s[5]++;
    trackError('google-auth', new Error('script load failure'), {
      details: response.details,
      error_code: response.error
    }, {
      skipSentry: true
    });
  };
  cov_2671cx13vl().s[6]++;
  var googleResponseFailure = function googleResponseFailure(response) {
    cov_2671cx13vl().f[2]++;
    var errorMessage = (cov_2671cx13vl().s[7]++, t('googleAuthError'));
    cov_2671cx13vl().s[8]++;
    setErrorMessage(errorMessage);
    cov_2671cx13vl().s[9]++;
    setErrorResponse(response);
    cov_2671cx13vl().s[10]++;
    trackError('google-auth', new Error(errorMessage), {
      details: response.details,
      error_code: response.error
    });
  };
  cov_2671cx13vl().s[11]++;
  var googleResponseSuccess = function googleResponseSuccess(response) {
    cov_2671cx13vl().f[3]++;
    cov_2671cx13vl().s[12]++;
    setErrorMessage('');
    cov_2671cx13vl().s[13]++;
    setErrorResponse(null);
    cov_2671cx13vl().s[14]++;
    trackEvent('google-auth', 'authed', {
      email: response.profileObj.email,
      name: response.profileObj.name
    }, {
      categoryOverride: 'login'
    });
    cov_2671cx13vl().s[15]++;
    return onAuthed(response);
  };
  cov_2671cx13vl().s[16]++;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(GoogleLogin, {
    clientId: clientId,
    onSuccess: googleResponseSuccess,
    onFailure: googleResponseFailure,
    onScriptLoadFailure: onScriptLoadFailure,
    render: function render(renderProps) {
      cov_2671cx13vl().f[4]++;
      cov_2671cx13vl().s[17]++;
      return /*#__PURE__*/React.createElement(Button, {
        analyticsName: "google-auth",
        label: (cov_2671cx13vl().b[1][0]++, buttonText) || (cov_2671cx13vl().b[1][1]++, t('continueWithGoogle')),
        width: '100%',
        size: "medium",
        variant: buttonVariant,
        onPress: renderProps.onClick,
        disabled: renderProps.disabled
      });
    }
  })), (cov_2671cx13vl().b[2][0]++, errorResponse) && (cov_2671cx13vl().b[2][1]++, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "$8x"
  }, /*#__PURE__*/React.createElement(ErrorPrompt, {
    message: errorMessage
  }))));
};
//# sourceMappingURL=GoogleAuth.mjs.map